function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "list");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Version-2.1---User-Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Wizard---Milestone-3-",
  transform: "translate(-459.000000, -643.000000)",
  stroke: "#00AEFF",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(206.000000, 644.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "list",
  transform: "translate(254.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 104.166667,
  height: 125
}), /*#__PURE__*/React.createElement("line", {
  x1: 50,
  y1: 33.3333333,
  x2: 83.3333333,
  y2: 33.3333333,
  id: "Path"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "18.75 33.3333333 22.9166667 37.5 35.4166667 25"
}), /*#__PURE__*/React.createElement("line", {
  x1: 50,
  y1: 62.5,
  x2: 83.3333333,
  y2: 62.5,
  id: "Path"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "18.75 62.5 22.9166667 66.6666667 35.4166667 54.1666667"
}), /*#__PURE__*/React.createElement("line", {
  x1: 50,
  y1: 91.6666667,
  x2: 83.3333333,
  y2: 91.6666667,
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 25,
  cy: 91.6666667,
  r: 6.25
})))));

var SvgMileStoneIconHouseHold = function SvgMileStoneIconHouseHold(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "107px",
    height: "127px",
    viewBox: "0 0 107 127",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMileStoneIconHouseHold, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mileStoneIconHouseHold.52568639.svg";
export { ForwardRef as ReactComponent };